import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface BkSegmentedOption {
  label: string;
  value: any;
}

/**
 * A pill-shaped segmented control (mutually exclusive options).
 * Use with two-way binding: `[value]="x" (valueChange)="x = $event"`.
 */
@Component({
  selector: 'bk-segmented-control',
  templateUrl: './bk-segmented-control.component.html',
  styleUrls: ['./bk-segmented-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BkSegmentedControlComponent {
  @Input() options: BkSegmentedOption[] = [];
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  select(value: any): void {
    if (value !== this.value) {
      this.value = value;
      this.valueChange.emit(value);
    }
  }
}
